import { FaTrash } from 'react-icons/fa';
import { SectionContent } from '@/contexts/ContentContext';

interface StatsFormProps {
  content: SectionContent;
  onChange: (field: string, value: any) => void;
  onArrayItemChange: (arrayField: string, index: number, field: string, value: any) => void;
  onAddItem: (arrayField: string, defaultValue: any) => void;
  onRemoveItem: (arrayField: string, index: number) => void;
}

const defaultStat = {
  number: 0,
  label: 'Novo Item',
  prefix: '',
  suffix: '+',
};

export function StatsForm({
  content,
  onChange,
  onArrayItemChange,
  onAddItem,
  onRemoveItem,
}: StatsFormProps) {
  const stats = content.stats || [];

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Título da Seção
          </label>
          <input
            type="text"
            value={content.title || ''}
            onChange={(e) => onChange('title', e.target.value)}
            className="w-full p-2 border rounded-md focus:ring-primary-500 focus:border-primary-500"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Subtítulo
          </label>
          <input
            type="text"
            value={content.subtitle || ''}
            onChange={(e) => onChange('subtitle', e.target.value)}
            className="w-full p-2 border rounded-md focus:ring-primary-500 focus:border-primary-500"
          />
        </div>
      </div>
      
      <div>
        <div className="flex justify-between items-center mb-2">
          <h4 className="text-sm font-medium text-gray-700">Estatísticas</h4>
          <button
            type="button"
            onClick={() => onAddItem('stats', defaultStat)}
            className="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs font-medium rounded text-primary-700 bg-primary-100 hover:bg-primary-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
          >
            <span className="mr-1">+</span> Adicionar Estatística
          </button>
        </div>
        
        <div className="space-y-4">
          {stats.map((stat, index) => (
            <div key={index} className="border p-4 rounded-lg">
              <div className="flex justify-between items-center mb-3">
                <h5 className="font-medium">Estatística {index + 1}</h5>
                <button
                  type="button"
                  onClick={() => onRemoveItem('stats', index)}
                  className="text-red-600 hover:text-red-800"
                >
                  <FaTrash className="h-4 w-4" />
                </button>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div>
                  <label className="block text-xs font-medium text-gray-500 mb-1">
                    Prefixo
                  </label>
                  <input
                    type="text"
                    value={stat.prefix || ''}
                    onChange={(e) => onArrayItemChange('stats', index, 'prefix', e.target.value)}
                    className="w-full p-2 border rounded-md text-sm focus:ring-primary-500 focus:border-primary-500"
                    placeholder="Ex: R$"
                  />
                </div>
                
                <div>
                  <label className="block text-xs font-medium text-gray-500 mb-1">
                    Número
                  </label>
                  <input
                    type="number"
                    value={stat.number || ''}
                    onChange={(e) => onArrayItemChange('stats', index, 'number', Number(e.target.value) || 0)}
                    className="w-full p-2 border rounded-md text-sm focus:ring-primary-500 focus:border-primary-500"
                  />
                </div>
                
                <div>
                  <label className="block text-xs font-medium text-gray-500 mb-1">
                    Sufixo
                  </label>
                  <input
                    type="text"
                    value={stat.suffix || ''}
                    onChange={(e) => onArrayItemChange('stats', index, 'suffix', e.target.value)}
                    className="w-full p-2 border rounded-md text-sm focus:ring-primary-500 focus:border-primary-500"
                    placeholder="Ex: %"
                  />
                </div>
                
                <div>
                  <label className="block text-xs font-medium text-gray-500 mb-1">
                    Rótulo
                  </label>
                  <input
                    type="text"
                    value={stat.label || ''}
                    onChange={(e) => onArrayItemChange('stats', index, 'label', e.target.value)}
                    className="w-full p-2 border rounded-md text-sm focus:ring-primary-500 focus:border-primary-500"
                    placeholder="Ex: Clientes Satisfeitos"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
